export default __webpack_public_path__ + "static/media/Armwrap of Intricate Spite.20d57857.jpg";